import { useEffect } from 'react';
import { useStarGridData } from '../context/StarGridDataContext';
import { isResourcePending } from './useAsyncResource';
import { StarGridInfra } from '../starGridTypes';

export interface UseStarGridInfraResult {
  infra: StarGridInfra | undefined;
  loading: boolean;
  error: string | undefined;
  refresh: () => void;
}

/** StarRocks infrastructure is fetched again whenever this view is entered. */
export function useStarGridInfra(): UseStarGridInfraResult {
  const { infra } = useStarGridData();
  const { ensureLoaded, data, error, refresh } = infra;

  useEffect(() => {
    ensureLoaded();
  }, [ensureLoaded]);

  return { infra: data, loading: isResourcePending(infra), error, refresh };
}
